import ProfileSettingsNav from "@/app/shared/account-settings/navigation";
import PageHeader from "@/app/shared/page-header";
import routes from "@/routers/routes";
import { Outlet } from "react-router-dom";

const pageHeader = {
    title: "Account Settings",
    breadcrumb: [
        {
            href: "/",
            name: "Home",
        },
        {
            href: routes.forms.profileSettings,
            name: "Form",
        },
        {
            name: "Account Settings",
        },
    ],
};

export default function ProfileSettingsLayout() {
    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            />
            <ProfileSettingsNav />
            {<Outlet />}
        </>
    );
}
